"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import shared from "./shared";
import styled from "styled-components";
import {
  accentColorPrimary,
  grey3,
  grey5,
  getAppearanceConstant,
  setAppearanceConstantLocal
} from "@churchofjesuschrist/eden-style-constants";
import { adjustHexAlpha } from "@churchofjesuschrist/eden-utilities";
const accentColorPrimaryModeStyle = getAppearanceConstant(accentColorPrimary);
const darkRootColor = accentColorPrimaryModeStyle.dark;
const [buttonGhostHoverDef, buttonGhostHover] = setAppearanceConstantLocal(
  "button-ghost-hover",
  {
    light: grey3,
    dark: adjustHexAlpha(darkRootColor, 0.16),
    prefix: "eden"
  }
);
const [buttonGhostActiveDef, buttonGhostActive] = setAppearanceConstantLocal(
  "button-ghost-active",
  {
    light: grey5,
    dark: adjustHexAlpha(darkRootColor, 0.24),
    prefix: "eden"
  }
);
const Component = styled.button`
  ${shared};
  ${buttonGhostHoverDef};
  ${buttonGhostActiveDef};
  background: none;
  color: ${accentColorPrimary};

  @media (any-hover: hover) {
    &:hover {
      background: ${buttonGhostHover};
      color: ${accentColorPrimary};
    }
  }

  &:active,
  &[aria-pressed="true"] {
    background: ${buttonGhostActive};
  }

  &[disabled],
  &[disabled]:hover {
    background: none;
  }
  &:is(a):visited:not(:active) {
    color: ${accentColorPrimary};
  }
`;
const GhostComponent = ({
  href,
  disabled,
  renderAs = href && !disabled ? "a" : "button",
  type = renderAs === "button" ? "button" : void 0,
  small,
  fullWidth,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  Component,
  {
    ...props,
    ref,
    type,
    href,
    disabled,
    $fullWidth: fullWidth,
    $small: small,
    as: renderAs,
    children: props.children
  }
);
const Ghost = forwardRef(GhostComponent);
Ghost.displayName = "Ghost";
var Ghost_default = Ghost;
export {
  Ghost_default as default
};
